import { AuthInfo, MenuItem } from "@shapeable/types";

export const menuItemIsAvailable = (auth: AuthInfo) => (item: MenuItem) => !(item.slug === 'explorer' && !auth.isAuthenticated);